import { render, staticRenderFns } from "./regionModuleAdmin.vue?vue&type=template&id=6bad51a0&scoped=true&"
import script from "./regionModuleAdmin.vue?vue&type=script&lang=js&"
export * from "./regionModuleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./regionModuleAdmin.vue?vue&type=style&index=0&id=6bad51a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad51a0",
  null
  
)

export default component.exports